"use client"

import dynamic from "next/dynamic"

// Code-split so guide pages without the tool never ship it, but server-rendered so its copy stays crawlable
const PercentileAssurancePret = dynamic(() => import("@/app/components/atomic/organisms/PercentileAssurancePret"))

const PercentileAssurancePretCompact = dynamic(
    () => import("@/app/components/atomic/organisms/PercentileAssurancePretCompact")
)

const PercentileAssurancePretLazy = ({ compact = false }: { compact?: boolean }) =>
    compact ? <PercentileAssurancePretCompact /> : <PercentileAssurancePret />

export default PercentileAssurancePretLazy
